<template>
  <div class="text-center confirm position-relative mx-auto">
    <Subheader v-if="title" :text="title" />
    <TextBlock
      v-if="text || textKey"
      variant="secondary"
      :text="textKey ? $t(textKey) : text"
    />
    <slot></slot>
    <div
      class="d-flex align-items-center justify-content-center mt-6 row no-gutters"
      style="min-width: 200px"
    >
      <HeraFormBtn
        v-if="cancelButtonText !== false"
        class="btn-secondary-simple flex-shrink-0 flex-grow-1 col"
        :class="cancel"
        :disabled="isLoading"
        @click.prevent="$emit('cancel')"
      >
        {{
          cancelButtonText ||
            $t('_web_stage_start_modal_confirmation_cancel', 'Cancel')
        }}
      </HeraFormBtn>
      <div
        v-if="cancelButtonText !== false && confirmButtonText !== false"
        class="spacer mx-3 px-2 col-auto"
      ></div>
      <HeraFormBtn
        v-if="confirmButtonText !== false"
        class="btn-accept-rules flex-shrink-0 flex-grow-1 col confirm-btn"
        :loading="isLoading"
        :disabled="confirmButtonDisabled || isLoading"
        @click.prevent="$emit('confirm')"
      >
        {{
          confirmButtonText ||
            $t('_web_stage_start_modal_confirmation_accept', 'Accept')
        }}
      </HeraFormBtn>
    </div>
  </div>
</template>

<script>
import HeraFormBtn from '@/components/atoms/HeraFormBtn';
import TextBlock from '@/components/atoms/TextBlock';
import Subheader from '@/components/atoms/Subheader';
import { prop } from '@/utils/factories';

export default {
  name: 'HeraConfirm',
  components: { HeraFormBtn, Subheader, TextBlock },

  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    textKey: {
      type: String,
      default: '',
    },
    cancelButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonText: {
      type: [String, Boolean],
      default: '',
    },
    confirmButtonDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    cancel: prop(String),
  },
};
</script>

<style lang="scss">
.confirm {
  width: 100%;
  max-width: 360px;
  button {
    max-width: 180px;
  }
}

.confirm-btn:hover {
  color: $hr-text-primary !important;
  background-color: $hr-bg-accent !important;
}

.cancel-btn {
  background-color: $hr-bg-modal-btn !important;
  border-radius: 5px !important;
  text-transform: uppercase;
  color: $hr-bg-accent !important;
}

.cancel-btn:hover {
  color: $hr-bg-modal-btn !important;
  background-color: $hr-bg-error !important;
}
</style>
